import { createUseStyles } from 'react-jss';
import { Classes } from 'jss';
import { ActionPalette, BrandPalette, GrayscalePalette } from '@tcl-boron-colors/colors';
import { StatusVariant, PRIMARY_STATUS_COLORS } from '@tcl-argon-utils/utils';
import React from 'react';

interface InputStylesData {
  status: StatusVariant;
  subContent: React.ReactNode;
}
export const useCommonInputStyles: (
  data?: InputStylesData & {
    theme?: Jss.Theme;
  },
) => Classes<'label' | 'isVisuallyHidden' | 'subContent'> = createUseStyles({
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: 700,
    height: 'auto',
    lineHeight: '20px',
    marginBottom: '5px',
    color: BrandPalette[700],
  },
  isVisuallyHidden: {
    position: 'absolute',
    left: '-10000px',
    top: 'auto',
    width: '1px',
    height: '1px',
    overflow: 'hidden',
  },
  subContent: ({ subContent, status }: InputStylesData) => {
    // Don't bother constructing subContent styles if no subContent exists
    if (subContent == null) {
      return {};
    }

    return {
      marginTop: '5px',
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '14px',
      color: status === 'default' ? GrayscalePalette[500] : PRIMARY_STATUS_COLORS[status],
      '& a': {
        color: ActionPalette[300],
        cursor: 'pointer',
        fontSize: '12px',
        fontWeight: '500',
        lineHeight: '14px',
        textDecoration: 'none',
        '&:hover': {
          textDecoration: 'underline',
        },
      },
    };
  },
});
